
	import { Component, Vue } from 'vue-property-decorator';
	import aps from '@/HostApp/store/ApsModules/ApsModule';
	import { serverProps } from '@/Common/Environment/const';
	import helpCenterServiceModule from '@/HostApp/services/HelpCenterService/HelpCenterServiceModule';

	@Component({
		components: {}
	})
	export default class TheNavBar extends Vue {
		protected state: APS.IServerProps = serverProps;

		protected notificationDefaultAction = '/ccp/v/pa/ccp-users/activityLog';

		protected get vueWorkspace(): boolean {
			return !!aps.navigation.vueWorkspace;
		}

		protected set vueWorkspace(value: boolean) {
			aps.navigation.enableWorkspace(value);
		}

		protected get hideNotifyControl(): boolean {
			//hardcode condition moved from old index.jsp
			return !!(
				this.viewParams.viewId &&
				this.viewParams.viewId === 'http://www.parallels.com/ccp-activation#activation-wizard'
			);
		}

		protected get userInfo(): APS.IUserInfo {
			const { user } = this.state.apsContext || {};

			const avatarUrl = user.avatarUrl ? `${user.avatarUrl}?bw_id=${aps.context._sessionId}` : '';

			return { ...user, avatarUrl };
		}

		protected get error404(): APS.IError404 {
			return this.state.error404;
		}

		protected get isShowUserMenu(): boolean {
			return this.state.isShowUserMenu;
		}

		protected get userMenu(): APS.IMenuItems {
			return this.isShowUserMenu
				? aps.navigation.userMenu || this.state.userMenu
				: ([] as never as APS.IMenuItems);
		}

		protected get helpMenu(): APS.IMenuItems | undefined {
			return this.isHelpMenuVisible ? aps.navigation.helpMenu || this.state.helpMenu : undefined;
		}

		protected get isHelpMenuVisible(): boolean {
			return this.state.isHelpMenuVisible;
		}

		protected get expertModeMenu(): APS.IMenuItem | null {
			return this.state.expertModeMenu;
		}

		protected get isShowNotifications(): boolean {
			return this.state.isShowNotifications && !this.hideNotifyControl;
		}

		protected get isShowNavigationBar(): boolean {
			return this.state.isShowNavigationBar;
		}

		protected get userDisplayName(): string {
			return this.state.userDisplayName;
		}

		protected get viewParams(): APS.IViewParams {
			return this.state.viewParams;
		}

		protected get notificationItems(): Array<APS.INotification> {
			return aps.notifications.sortedNotifications;
		}

		protected get isHelpCenterEnabled(): boolean {
			return helpCenterServiceModule.isEnabled || false;
		}

		protected onActionRequired(href: string): void {
			aps.navigation.openLink(href);
		}

		protected onOpenHelpCenter(): void {
			helpCenterServiceModule.setIsHelpCenterOpened(true);
		}

		protected handleMarkAsRead(id: string): void {
			aps.notifications.markAsRead(id);
		}

		protected handleNotificationClosed(): void {
			aps.notifications.markAllAsRead();
		}
	}
